import { useEffect, useRef, useState } from "react";
import { View, Text, ScrollView, Platform } from "react-native";
import React from "react";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../components/LoadingIndicator";
import {
	Box,
	FormControl,
	Stack,
	Input,
	Heading,
	Select,
	Divider,
	useMediaQuery,
	Button,
	useTheme,
	IconButton,
} from "native-base";
import { Picker } from "@react-native-picker/picker";
import DateTimePicker from "@react-native-community/datetimepicker";
import submitMissingData from "../../common/submitMissingData";
import dayjs from "dayjs";
import { isWeb } from "../../utils/utils";
import { Ionicons } from "@expo/vector-icons";
import SuccessToast from "../../components/SuccessToast";

const Application = isWeb()
	? require("react-rainbow-components").Application
	: null;

const DatePicker = isWeb()
	? require("react-rainbow-components").DatePicker
	: null;

const MissingData = ({
	generalInfo,
	AddressInfo,
	PrimaryIdInfo,
	SecondaryIdInfo,
	navigation,
}) => {
	const [showDate, setShowDate] = useState(false);
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [missingUserData, setMissingUserData] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const MissingMemberData = useSelector(
		(state) => state.MissingData.MissingData
	);
	const [selectedDate, setSelectedDate] = useState("");

	const Auth = useSelector((state) => state.Login.Auth);

	const { colors } = useTheme();
	const theme = {
		rainbow: {
			palette: {
				brand: colors.primary["400"],
			},
		},
	};

	const onChange = (
		value,
		label = null,
		dataTypeGuid = null,
		validationType = null
	) => {
		value = textFieldValidator(value, validationType);

		if (value?.target?.value) {
			if (missingUserData.find((val) => val.datatype_name === label)) {
				let MissingData = missingUserData;
				MissingData.find((val) => val.datatype_name === label).data_text =
					value.target.value;

				setMissingUserData([...missingUserData]);
			} else {
				setMissingUserData([
					...missingUserData,
					{
						datatype_guid: dataTypeGuid,
						data_text: value.target.value,
						datatype_name: label,
					},
				]);
			}
		} else {
			if (missingUserData.find((val) => val.datatype_name === label)) {
				let MissingData = missingUserData;
				MissingData.find((val) => val.datatype_name === label).data_text =
					value;

				setMissingUserData([...missingUserData]);
			} else {
				setMissingUserData([
					...missingUserData,
					{
						datatype_guid: dataTypeGuid,
						data_text: value,
						datatype_name: label,
					},
				]);
			}
		}
	};

	const textFieldValidator = (value, validationType) => {
		switch (validationType) {
			case "numeric":
				return value.replace(/\D+/g, "");
			case "alphanumeric":
				return value;
			case "characters":
				return value.replace(/[0-9]/g, "");
			default:
				return value;
		}
	};

	const handleSubmitMissingUserData = async () => {
		try {
			setIsSubmitting(true);
			let params = {
				data: missingUserData,
			};

			let result = await submitMissingData(
				Auth.storemember_guid,
				Auth.session_token,
				params
			);

			if (result.data.result) {
				setIsSubmitting(false);
				SuccessToast("Successfully submitted", "Missing Info");
				navigation.navigate("Main Menu");
			}
		} catch (error) {
			console.log(error.message);
			setIsSubmitting(false);
			if (error.data?.error) {
				ErrorToast(error.data.error, "Missing Info");
			} else {
				ErrorToast(error.message, "Missing Info");
			}
		}
	};

	const componentGenerator = (control, index) => {
		if (control.datatype_metadata.validations.input_type === "text") {
			return (
				<View key={control.datatype_label}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					<Input
						borderWidth={2}
						onChangeText={(value) =>
							onChange(
								value,
								control.datatype_name,
								control.datatype_guid,
								control?.datatype_metadata?.validations?.validationType
							)
						}
						placeholder={`${control.datatype_label}`}
						label={`${control.datatype_label}`}
						value={
							missingUserData.find(
								(val) => val.datatype_name === control.datatype_name
							)?.data_text
						}
					/>
				</View>
			);
		} else if (control.datatype_metadata.validations.input_type === "select") {
			return (
				<View key={control.datatype_label}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					{isWeb() ? (
						<Select
							borderWidth={2}
							onValueChange={(value) =>
								onChange(value, control.datatype_name, control.datatype_guid)
							}
							name={`${control.datatype_label}`}
							selectedValue={
								missingUserData.find(
									(val) => val.datatype_name === control.datatype_name
								)?.data_text
							}
							placeholder={` Select ${control.datatype_label}`}
						>
							{control?.datatype_metadata?.validations?.select_options?.map(
								(item, index) => {
									return (
										<Select.Item
											key={index}
											label={Object.values(item)[0]}
											value={Object.keys(item)[0]}
										/>
									);
								}
							)}
						</Select>
					) : (
						<View
							style={{
								borderColor: "rgb(220, 38, 38)",
								borderWidth: 2,
								borderRadius: 20,
							}}
						>
							<Picker
								itemStyle={{ fontSize: 12 }}
								type="dialog"
								onValueChange={(value) =>
									onChange(value, control.datatype_name, control.datatype_guid)
								}
								name={`${control.datatype_label}`}
								selectedValue={
									missingUserData.find(
										(val) => val.datatype_name === control.datatype_name
									)?.data_text
								}
								placeholder={` Select ${control.datatype_label}...`}
								numberOfLines={2}
							>
								<Picker.Item
									enabled={true}
									style={{ color: "#d5d5d5" }}
									label={`Select ${control.datatype_label}`}
									value={""}
								/>
								{control?.datatype_metadata?.validations?.select_options?.map(
									(item, index) => {
										return (
											<Picker.Item
												key={index}
												label={Object.values(item)[0]}
												value={Object.keys(item)[0]}
											/>
										);
									}
								)}
							</Picker>
						</View>
					)}
				</View>
			);
		} else if (control.datatype_metadata.validations.input_type === "date") {
			return (
				<View key={control.sitepagecomponent_guid}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					{isWeb() ? (
						<Application theme={theme}>
							<DatePicker
								error={` `}
								placeholder={`${control.datatype_label}`}
								onChange={(value) =>
									onChange(
										dayjs(value).format("YYYY-MM-DD"),
										control.datatype_name,
										control.datatype_guid
									)
								}
								value={
									missingUserData.find(
										(val) => val.datatype_name === control.datatype_name
									)
										? new Date(
												missingUserData.find(
													(val) => val.datatype_name === control.datatype_name
												)?.data_text
										  )
										: null
								}
								placehplaceholder={`${control.datatype_label}`}
								formatStyle="medium"
								locale="en-ZA"
								style={{
									fontFamily: "NotoSansRegular",
									fontSize: 10,
								}}
							/>
						</Application>
					) : (
						<>
							<Input
								borderWidth={2}
								onPressIn={() => {
									setSelectedDate(control.datatype_name);
									setShowDate(true);
								}}
								onChangeText={(value) =>
									onChange(value, control.datatype_name, control.datatype_guid)
								}
								showSoftInputOnFocus={false}
								value={
									missingUserData.find(
										(val) => val.datatype_name === control.datatype_name
									)
										? dayjs(
												missingUserData.find(
													(val) => val.datatype_name === control.datatype_name
												)?.data_text
										  ).format("YYYY-MM-DD")
										: ""
								}
								type="text"
								InputRightElement={
									<IconButton
										size="sm"
										onPress={() => {
											setSelectedDate(control.datatype_name);
											setShowDate(true);
										}}
										_icon={{
											as: Ionicons,
											name: "calendar",
											color: "primary.500",
											size: "sm",
										}}
									></IconButton>
								}
								placeholder={`${control.datatype_label}`}
							/>
							{showDate && control.datatype_name === selectedDate && (
								<DateTimePicker
									mode="date"
									is24Hour={true}
									display="default"
									value={
										missingUserData.find(
											(val) => val.datatype_name === control.datatype_name
										)
											? new Date(
													missingUserData.find(
														(val) => val.datatype_name === control.datatype_name
													)?.data_text
											  )
											: new Date()
									}
									onChange={(event, value) => {
										setShowDate(false);
										onChange(
											value,
											control.datatype_name,
											control.datatype_guid
										);
									}}
								/>
							)}
						</>
					)}
				</View>
			);
		} else if (control.datatype_metadata.validations.input_type === "number") {
			return (
				<View key={control.datatype_label}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					<Input
						keyboardType="number-pad"
						borderWidth={2}
						onChangeText={(value) =>
							onChange(value, control.datatype_name, control.datatype_guid)
						}
						placeholder={`${control.datatype_label}`}
						label={`${control.datatype_label}`}
						value={
							missingUserData.find(
								(val) => val.datatype_name === control.datatype_name
							)?.data_text
						}
					/>
				</View>
			);
		}
	};

	return (
		<>
			{!MissingMemberData.component_children ? (
				<LoadingIndicator />
			) : (
				<View>
					<View
						style={{
							marginVertical: 10,
						}}
					>
						<View
							style={{
								flexDirection: "row",
								alignItems: "baseline",
								justifyContent: "center",

								flexWrap: "wrap",
							}}
						>
							<Heading color="primary.500">Missing information</Heading>
							<Heading size="sm" style={{ color: "#777777" }}>
								{" "}
								Please update your profile
							</Heading>
						</View>
						<Text size="xs" style={{ color: "#777777", textAlign: "center" }}>
							Please note that the information is required and you will not be
							able to access any other functionality without providing the
							required information.
						</Text>
					</View>
					<Divider />
					<Box
						bg="#fff"
						padding={isDesktopOrLaptop[0] ? "20px" : "2px"}
						borderRadius="5px"
						flex="3"
					>
						<FormControl isRequired isInvalid={true}>
							<Stack mx="3" space={2.5}>
								<Heading size="sm" color="primary.500">
									{MissingMemberData.component_description}
								</Heading>
								{generalInfo.length > 0 && (
									<View
										style={{
											padding: isDesktopOrLaptop[0] ? 20 : 5,
											borderWidth: 1,
											borderRadius: 5,
											borderColor: "#dedede",
										}}
									>
										<Heading
											size="sm"
											color="primary.500"
											style={{ marginVertical: 10 }}
										>
											General Information
										</Heading>
										{generalInfo.map((control, index) =>
											componentGenerator(control, index)
										)}
									</View>
								)}
								{AddressInfo.length > 0 && (
									<View
										style={{
											padding: 20,
											borderWidth: 1,
											borderRadius: 5,
											borderColor: "#dedede",
										}}
									>
										<Heading
											size="sm"
											color="primary.500"
											style={{ marginVertical: 10 }}
										>
											Residential Address
										</Heading>
										{AddressInfo.map((control, index) =>
											componentGenerator(control, index)
										)}
									</View>
								)}
								{PrimaryIdInfo.length > 0 && (
									<View
										style={{
											padding: 20,
											borderWidth: 1,
											borderRadius: 5,
											borderColor: "#dedede",
										}}
									>
										<Heading
											size="sm"
											color="primary.500"
											style={{ marginVertical: 10 }}
										>
											Primary Identify
										</Heading>
										{PrimaryIdInfo.map((control, index) =>
											componentGenerator(control, index)
										)}
									</View>
								)}
								{SecondaryIdInfo.length > 0 && (
									<View
										style={{
											padding: 20,
											borderWidth: 1,
											borderRadius: 5,
											borderColor: "#dedede",
										}}
									>
										<Heading
											size="sm"
											color="primary.500"
											style={{ marginVertical: 10 }}
										>
											Secondary Identify
										</Heading>
										{SecondaryIdInfo.map((control, index) =>
											componentGenerator(control, index)
										)}
									</View>
								)}
								<Button
									onPress={handleSubmitMissingUserData}
									isLoading={isSubmitting}
									isLoadingText="Submitting"
									variant={isSubmitting ? "outline" : "solid"}
									style={
										isDesktopOrLaptop[0]
											? {
													marginLeft: "auto",
											  }
											: {}
									}
								>
									Submit
								</Button>
							</Stack>
						</FormControl>
					</Box>
				</View>
			)}
		</>
	);
};

export default MissingData;
